import styled from 'styled-components';

import { BaseSearchIcon } from '../../svg';
import { colors } from '../../constants';

const SearchIcon = styled(BaseSearchIcon)`
    fill: ${colors.greyDark};
    width: 24px;
    height: 24px;
`;

interface IProps {
    className?: string;
    onClick?(): void;
}

const BaseSearchButton = ({ className, onClick }: IProps) => (
    <div className={className} role="button" onClick={onClick}>
        <SearchIcon />
    </div>
);

export const SearchButton = styled(BaseSearchButton)`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.greyDark};
`;
